import {gql} from "@apollo/client";

export const duplicateJobTemplateMutation = gql`
    mutation createJobTemplate($data: CreateJobTemplateInput!) {
      createJobTemplate(data: $data) {
        id
      }
    }
`;

export default duplicateJobTemplateMutation;